// Utility function to handle FastAPI validation errors
export const extractErrorMessage = (error: any): string => {
  // If error.response exists, it's an axios error
  if (error.response?.data) {
    const errorData = error.response.data;
    
    // Handle FastAPI validation errors (422 status - typically an array in detail)
    if (error.response.status === 422 && errorData.detail && Array.isArray(errorData.detail)) {
      // Extract error messages from validation error array
      const messages = errorData.detail.map((errItem: any) => { // Renamed 'err' to 'errItem' to avoid confusion
        if (errItem.msg) {
          return `${errItem.loc?.join('.') || 'Field'}: ${errItem.msg}`;
        }
        return 'Validation error';
      });
      return messages.join(', ');
    }
    
    // Handle regular HTTP errors with detail field (string)
    if (typeof errorData.detail === 'string') {
      return errorData.detail;
    }
    
    // Handle regular HTTP errors with detail field (object - potentially a single FastAPI error item)
    if (typeof errorData.detail === 'object' && errorData.detail !== null) {
      // If detail is an object like {type, loc, msg...}, stringify it or format it.
      if (errorData.detail.msg && typeof errorData.detail.loc !== 'undefined') {
        return `${errorData.detail.loc?.join('.') || 'Field'}: ${errorData.detail.msg}`;
      }
      return JSON.stringify(errorData.detail);
    }
    
    // Handle cases where errorData itself is the error object (e.g., {type, loc, msg,...})
    // This is a common structure for single, non-422 validation-like errors.
    if (typeof errorData === 'object' && errorData !== null && errorData.msg && typeof errorData.loc !== 'undefined') {
      return `${errorData.loc?.join('.') || 'Field'}: ${errorData.msg}`;
    }

    // Handle other error formats where errorData has a message property
    if (errorData.message && typeof errorData.message === 'string') {
      return errorData.message;
    }
    
    // Fallback for unknown error structure within error.response.data
    return 'An error occurred (from response data)';
  }
  
  // Handle network or other errors (error.response is not available)
  if (error.message && typeof error.message === 'string') {
    return error.message;
  }
  
  // Final fallback for truly unexpected error structures
  return 'An unexpected error occurred (unknown structure)';
};
